
import {spApi} from './sp'

export const switchSubscriptionApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    switchSubscription: builder.mutation({
     
      query: ({payload}) => ({
        url: '/switchsubscriptionplan',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Subscription'],
    }),

  }),
  overrideExisting: false,
})

export const { useSwitchSubscriptionMutation } = switchSubscriptionApi